// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__OiDTY","label":"Section_label__87vlx","contentWrap":"Section_contentWrap__28D8p","footer":"Section_footer__UMQv6","footerInner":"Section_footerInner__26zvB"};